import React from 'react'
import { TagSetContainer } from 'containers'
import { Button } from 'components'
import { isMobile } from 'utils/deviceDetector'

import styles from './NotificationBoxFooter.module.scss'

const NotificationBoxFooter = ({
  tagsDisplay = 'all',
  renderTitle = null,
  showFilterButton = false,
  onClick = null,
  openFilterModal = null,
}) => {
  return (
    <div className={styles.notificationFooterContainer}>
      {renderTitle && renderTitle()}
      <TagSetContainer tagsDisplay={tagsDisplay} />
      {(isMobile || showFilterButton) && (
        <>
          <Button
            id="filterButton"
            name="filterButton"
            onClick={onClick || openFilterModal}
            iconPosition="right"
            textColor="darkColor"
            icon="filter"
            type="outline"
            darkColor
            backgroundColor="darkColor"
          >
            Editar filtros
          </Button>
        </>
      )}
    </div>
  )
}

export default NotificationBoxFooter
